import { Component, Input, OnInit } from '@angular/core';
import { AuthorizationFrontendService } from '../../services/authorizationfrontend.service';
import { UserFrontendService } from '../../../shared/services';

@Component({
    selector: 'authorizationfrontend-profile',
    templateUrl: 'authorizationfrontend-profile.component.html',
    styleUrls: ['authorizationfrontend-profile.component.scss'],
})
export class AuthorizationFrontendProfileComponent implements OnInit {

    @Input() showText: boolean = true;
    @Input() color: string = "";

    panelShown: boolean = false;

    private toggleTimeoutId: number|null = null;

    constructor(private authSevice: AuthorizationFrontendService, private userService: UserFrontendService) {}

    ngOnInit(): void {
        if (!this.color) {
            this.color = "";
        }
    }

    togglePanel() {
        if (this.toggleTimeoutId !== null) {
            return;
        }
        this.toggleTimeoutId = setTimeout(() => {
            this.panelShown = !this.panelShown;
            this.toggleTimeoutId = null;
        }, 50);
    }

    sub() {
        return this.userService.sub;
    }

    email() {
        return this.userService.userData?.idToken?.email || "";
    }

    name() {
        return this.userService.userData?.idToken?.name || "";
    }

    profileUrl() {
        return this.userService.userData?.profileUrl;
    }

    /**
     * Appelé pour fermer la session l’utilisateur.
     */
    async logout() {
        await this.authSevice.closeSession();
    }
}
